<template>
  <div class="favorites-content">
    <div>
        <!-- Favorite items -->
        <div
          v-for="(item, index) in results"
          :key="index"
          class="p-2"
        >
          <Transition name="fade">
            <contract-favorite
              v-if="item.type === FAV_TYPE_CONTRACT"
              :id="item.id"
              @shortcut-click="forwardShortcut"
              @remove="removeFavorite(index)"
            />
          </Transition>
        </div>
        <!-- Add new favourite -->
        <div class="p-2" @click="addNew = true">
          <Transition name="fade">
            <div class="favorite-container-empty">
              <font-awesome-icon icon="plus" />
            </div>
          </Transition>
        </div>
    </div>
    <base-modal v-if="addNew" hide-header hide-footer @close="addNew = false">
      <favorites-selector @close="addNew = false" @new-favorite="addFavorite"/>
    </base-modal>
  </div>
</template>

<script>
import {restApi} from '../mixins/RestApiMixin'
import ContractFavorite from "@/components/favorites/ContractFavorite";
import FavoritesSelector from "@/components/favorites/FavoritesSelector";
import BaseModal from "../BaseModal";

export default {
    name: 'Favorites',
    components: {BaseModal, FavoritesSelector, ContractFavorite},
    mixins: [restApi],
    emits: ['shortcutClicked'],
    data: function () {
        return {
            FAV_TYPE_CONTRACT: 1,
            results: [],
            addNew: false
        }
    },
    mounted: function () {
        this.fetchFavorites()
    },
    methods: {

        async fetchFavorites() {
            const response = await this.fetchUserPreferences('favorites');
            if (response) {
                if (response.data && response.data.preferences) {
                    this.results = response.data.preferences
                }
            }
        },

        removeFavorite(index) {
            this.results.splice(index, 1)
            this.saveFavorites()
        },

        forwardShortcut(view, item) {
            this.$emit('shortcutClicked', view, item)
        },

        addFavorite(type, id) {
            this.results.push({ type: type, id: id })
            this.saveFavorites()
            this.addNew = false
        },

        async saveFavorites() {
            return await this.upsertUserPreferences('favorites', this.results);
        },
    }
}
</script>

<style scoped>
.favorites-content {
    padding: 0.5em;
    overflow-y: auto;
    overflow-x: hidden;
    height: 100%;
    background: #f8f8f8;
}

.favorites-content :deep(.favorite-container),
.favorites-content :deep(.favorite-container-empty) {
    display: block;
    width: 100%;
    box-sizing: border-box;
    border: 1px solid #dee2e6;
    box-shadow: none;
}
</style>
